export class AddClusterProduct {
  private clusterId: string;
  private ean: string;

  public getClusterId(): string {
    return this.clusterId;
  }

  public getEan(): string {
    return this.ean;
  }

  public setClusterId(value: string) {
    this.clusterId = value;
  }

  public setEan(value: string) {
    this.ean = value;
  }
}
